import { PanelView, TimePanelSettingStore } from './schema/TimePanelSettingsStore';
import { createNavigationStack } from 'owa-navigation-stack';
import { isConsumer } from 'owa-session-store';
import { getOwaWorkload, OwaWorkload } from 'owa-workloads';
import { createStore } from 'satcheljs';

export const getStore = createStore<TimePanelSettingStore>('timePanelSettingStore', {
    panelViewStack: createNavigationStack<PanelView>(getInitialPanelView()),
    // for consumer users, default to true to optimize for date navigation over view density
    isDatePickerExpanded: isConsumer(),
});

export function getInitialPanelView(): PanelView {
    return getOwaWorkload() !== OwaWorkload.Calendar ? 'Calendar' : 'Tasks';
}
